import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectStoreComponent } from './select-store.component';
import { IonicModule } from '@ionic/angular';



@NgModule({
  declarations: [SelectStoreComponent],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports:[SelectStoreComponent]
})
export class SelectStoreModule { }
